type CompetenceWithCode = {
  code?: string | null;
};

export function nextCompetenceCode(
  prefix: string,
  competences: CompetenceWithCode[]
) {
  const codePrefix = `${prefix}-`;
  const maxSequence = competences.reduce((max, competence) => {
    const code = competence.code || '';
    if (!code.startsWith(codePrefix)) return max;

    const suffix = code.slice(codePrefix.length);
    if (!/^\d+$/.test(suffix)) return max;

    const sequence = Number(suffix);
    return Number.isSafeInteger(sequence) ? Math.max(max, sequence) : max;
  }, 0);

  return `${prefix}-${String(maxSequence + 1).padStart(3, '0')}`;
}
